import React, { useState, useEffect, useRef } from 'react';
 
import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import moment from 'moment';
import { ActualizarOrdenPagoF } from './modalActualizarOrdenPagoF';
import ValidarUsuario from '../comun/modalValidarUsuario';
import { Input } from '../../ui/inputs/Input';
import { PrimaryButton } from '../../ui/buttons/Button';

const TablaOrdenesdePagosF = (props) => {
  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
  const espiritu = JSON.parse(localStorage.getItem('espiritu'));
  //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
  const norden = true;
  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° ORDEN', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'PROVEEDOR', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]
  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [ordenp, setOrdenp] = useState();
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
  const [ordenPago, setOrdenPago] = useState();
  const [mostrarUsuario, setMostrarUsuario] = useState(false);

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {

            if ((norden ? x.numordenpago.includes(target.value) : x.idordenpago.includes(target.value))
              || x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
              || moment.utc(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })
  }

  const seleccionarRegistros = () => {
    setOrdenPago();
    let orden = '';
    if (espiritu === 0 || espiritu === 2 || espiritu === 4) {
      orden = 'idordenpago';
    } else {
      orden = 'numordenpago';
    }
    let desde = '2';
    let endpoint = `${op.conexion}/api/administracion/registrosordenesdepagomodulo?idefiscal=${idefiscal}&orden=${orden}&desde=${desde}`;
    setActivate(true);
    console.log(endpoint)
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        setRecords(response.data);
      }
      setActivate(false)
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  }
  const SeleccionarOrdenPago = (data, ope) => {
    let id = norden ? data.numordenpago : data.idordenpago;
    let endpoint = `${op.conexion}/api/administracion/seleccionarordenpagofinanciera?idefi=${idefiscal}&&idordenp=${id}&espiritu=${espiritu}&norden=${norden}`
    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        if (response.data.length > 0) {
          if (response.data[0].ubicacion !== '42' && ope !== 4) {
            setMensaje({ mostrar: true, titulo: 'Informacion.', texto: response.data[0].mensajeubi, icono: 'informacion' });
          } else if (ope === 2 && response.data[0].retenapro === true){
            setMensajesino({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden Tiene Retenciones Trasladadas \n Pertenecientes al Traslado N°: ' + response.data[0].idapro + '\n' + '¿Desea Continuar?', icono: 'informacion' });
          } else if (ope === 3 && response.data[0].retenapro === true){
            setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden Tiene Retenciones Trasladadas \n Pertenecientes al Traslado N°: ' + response.data[0].idapro + '\n' + 'No Puede ser Eliminada', icono: 'informacion' });
          } else {
            setOrdenPago(response.data[0]);
            setMostrar2(true);
          }
        } else {
          setOrdenPago();
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    setMostrar2(true);

  };

  const gestionarOrdenPago = (op, data) => (e) => {
    if (op === 4) {
      setOperacion(4);
      SeleccionarOrdenPago(data, op);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true)
    } else if (op === 2) {
      if (data.conceptoorden !== null && data.tipo === 2) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La orden de pago es de fondo de tercero', icono: 'informacion' });
      } else if (data.reversado > 0) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden de Pago ya fue Reversada', icono: 'informacion' });
      } else if (data.status === 1) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden de Pago ya fue Pagada', icono: 'informacion' });
      } else {
        setOperacion(op);
        SeleccionarOrdenPago(data, op);
      }
    } else if (op === 3) {
      if (data.reversado === 0) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La orden de pago no ha sido Reversada', icono: 'informacion' });
      } else if (data.status === 1) {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden de Pago ya fue Pagada', icono: 'informacion' });
      } else {
        setOrdenp(data);
        setMostrarUsuario(true)
      }
    } else if (op === 5) {
      if (data.reversado > 0) {
        setOperacion(op);
        SeleccionarOrdenPago(data.idordenpago, op);
      } else {
        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'Debe Reversar La Orden de Pago para poder Eliminar el Registro', icono: 'informacion' });
      }
    }
  }
  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);
  const handleCancelar = () => {
    setOrdenPago();
    setMostrar2(false);
  }
  const cerrar = () => {
    props.setTabla(0)
  }
  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    setOperacion(3);
    SeleccionarOrdenPago(ordenp, 3);
  }

  return (
    <div className='col-8 m-0 p-0 mx-auto mt-5'>
      <header className='col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top'>
          <h3 className='m-0'>
            Ordenes de Pago
          </h3>
          <a type='button' onClick={cerrar}>
            salir<i className="fas fa-times ms-2"></i>
          </a>
      </header>
      <form onSubmit={(e)=>{e.preventDefault()}} 
      className='col-12 m-0 p-2 d-flex justify-content-between'>
        <div className='col-4 m-0 p-0'>
          <Input 
            ref={txtBuscador} 
            onChange={handleSearch} 
            placeholder="Buscar"
            className='search-input' 
          />
        </div>
        <PrimaryButton onClick={gestionarOrdenPago(1, '')} icon='fas fa-plus m-0'>
        </PrimaryButton>
      </form>
      <div className="col-12 m-0 p-0" >
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{norden ? item.numordenpago : item.idordenpago}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '300px' }}>{item.razonsocial}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '100px' }}>
                    <button onClick={gestionarOrdenPago(4, item)} className="btn btn-sm mx-1 btn-info rounded-circle" title='Consultar Orden de Pago'><i className="fas fa-eye"></i></button>
                    <button onClick={gestionarOrdenPago(2, item)} className="btn btn-sm mx-1 btn-success rounded-pill" title='Reversar Orden de Pago'><i className="fas fa-sync-alt"></i></button>
                    <button onClick={gestionarOrdenPago(3, item)} className="btn btn-sm mx-1 btn-danger rounded-circle" title='Eliminar Orden de Pago'><i className="fa fa-trash-alt"></i></button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ActualizarOrdenPagoF
        show={mostrar2}
        operacion={operacion}
        norden={norden}
        ordenp={ordenPago}
        titulo={operacion === 4 ? 'Consultar Orden Pago' : operacion === 2 ? 'Reversar Orden Pago' : operacion === 1 ? 'Incluir Orden Pago' : 'Eliminar Orden Pago'}
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />

      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => { setMostrarUsuario(false) }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={0}
      />
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
      
<Dimmer active={activate} inverted>
      </Dimmer>

    </div>
  );
}
export default TablaOrdenesdePagosF;